<template>
  <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      :module="module"
      :url="url"
      :span-merge-keys="spanMergeKeys"
      @addOrEdit="$emit('addOrEdit', $event)"
      @delete="$emit('delete', $event)"
      @select="$emit('select', $event)"
      @reset="$emit('reset', $event)">
    <template slot="otherBtn">
      <slot name="otherBtn"></slot>
    </template>
    <template slot="adSearch">
      <slot name="adSearch"></slot>
    </template>
  </viewTable>
</template>

<script>
import ViewTable from './ViewTable.vue'

export default {
  name: 'GroupedViewTable',
  components: { ViewTable },
  props: {
    limits: {
      type: Object,
      default: () => {
        return {
          addAuth: false,
          editAuth: false,
          delAuth: false,
        };
      },
    },
    columnsProperty: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
    },
    module: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    spanMergeKeys: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      // 存储分组数据的映射，键为分组字段值，值为该分组的所有记录
      groupMap: new Map(),
    }
  },
  mounted() {
    // 重写ViewTable组件的loadData方法
    const originalLoadData = this.$refs.viewTable.loadData;
    this.$refs.viewTable.loadData = this.customLoadData.bind(this, originalLoadData);
  },
  methods: {
    // 自定义loadData方法，实现分组功能
    customLoadData(originalLoadData, pageNum) {
      let that = this.$refs.viewTable;
      if (pageNum) {
        that.pagination.currentPage = pageNum;
      }
      that.loading = true;
      let params = Object.assign({ pageSize: that.pagination.pageSize, pageNum: that.pagination.currentPage }, that.filter);
      that.$http
        .get(`${that.module}`, `${that.url}`, params)
        .then((res) => {
          if (res.success) {
            const records = res.data.records;
            // 检查是否需要按指定字段分组
            const needGroup = records.length > 0 && 
                             this.spanMergeKeys && 
                             this.spanMergeKeys.length > 0 && 
                             records[0].hasOwnProperty(this.spanMergeKeys[0]);
            
            if (needGroup) {
              const groupField = this.spanMergeKeys[0];
              // 按分组字段分组
              const groupedData = [];
              const groupMap = new Map();
              
              // 先按分组字段分组
              records.forEach(record => {
                const groupValue = record[groupField] || '';
                if (!groupMap.has(groupValue)) {
                  groupMap.set(groupValue, []);
                }
                groupMap.get(groupValue).push(record);
              });
              
              // 将分组后的数据转换为树形结构
              groupMap.forEach((items, groupValue) => {
                if (groupValue) { // 只处理分组值不为空的数据
                  const group = {
                    ...items[0], // 使用第一条记录的属性作为组的属性
                    details: items
                  };
                  groupedData.push(group);
                } else {
                  // 分组值为空的数据直接添加
                  groupedData.push(...items);
                }
              });
              
              // 扁平化处理分组后的数据
              const flatData = this.flattenTree(groupedData);
              that.tableData = flatData;
            } else {
              that.tableData = records;
            }
            that.pagination.total = res.data.total;
          }
          that.loading = false;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    
    // 将树形数据转换为表格需要的扁平数组，并在首条明细上标注合并信息
    flattenTree(list) {
      if (!Array.isArray(list)) return [];
      const flat = [];
      for (const group of list) {
        const children = Array.isArray(group.details) && group.details.length > 0 ? group.details : [Object.assign({}, group)];
        const rowspan = children.length || 1;
        for (let i = 0; i < children.length; i++) {
          const childRaw = children[i] || {};
          // 合并父级属性到子行，子级同名字段优先保留
          const parentProps = Object.keys(group).filter(key => key !== 'details').reduce((acc, key) => {
            acc[key] = group[key];
            return acc;
          }, {});
          
          const merged = Object.assign({}, parentProps, childRaw);
          
          // 为合并行设置标记
          merged._groupStart = i === 0;
          merged._groupRowspan = i === 0 ? rowspan : 0;
          merged._groupTotal = rowspan;
          
          flat.push(merged);
        }
      }
      return flat;
    },
    
    // 暴露ViewTable的方法
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    }
  }
}
</script>